import { maxWidth } from '@/assets/styles/mixins.css.js';
import styled, { css } from 'styled-components';
import vars from '@/assets/styles/vars';
import Container from './StyledContainer';
import Button from './StyledButton';
import Breadcrumbs from './StyledBreadcrumbs';

const Hero = styled.div`
  overflow: hidden;
  order: -10;
  ${maxWidth(vars.breakpoints.tablet)`
    padding-top: 61px;
  `}

  ${(props) =>
    props.center &&
    css`
      text-align: center;

      ${maxWidth(vars.breakpoints.tablet)`
        text-align:left;
      `}

      ${Hero.Container} {
        align-items: center;

        ${maxWidth(vars.breakpoints.tablet)`
          align-items:flex-start;
        `}
      }
      ${Breadcrumbs} {
        justify-content: center;

        ${maxWidth(vars.breakpoints.tablet)`
          justify-content:flex-start;
        `}
      }
    `}

  ${(props) =>
    props.isStatic &&
    css`
      position: relative;
      ${Hero.Item} {
        position: relative;
      }
    `}
  
   ${(props) =>
  props.size === 'large' &&
  css`
    ${Hero.Container} {
      padding: 0;
      justify-content:flex-end !important;

    }
    ${Hero.Content} {
      padding: 0 140px 70px 0;
      &::after {
        content:'';
        width: 58px;
        height: 60px;
        position:absolute;
        right:78px;
        bottom:65px;
        background-image: url("data:image/svg+xml,%3Csvg width='58' height='60' viewBox='0 0 58 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M28.8789 23.4507L28.8789 36.7052' stroke='white'/%3E%3Cpath d='M23 30.7109L28.8789 36.7049L34.7578 30.7109' stroke='white'/%3E%3Cpath d='M29 0.5C44.7309 0.5 57.4998 13.5047 57.5 29.5674C57.5 45.6303 44.731 58.6357 29 58.6357C13.269 58.6357 0.5 45.6303 0.5 29.5674C0.500206 13.5047 13.2691 0.5 29 0.5Z' stroke='white'/%3E%3C/svg%3E%0A");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
      }
      ${maxWidth(vars.breakpoints.tablet)`
          padding: 0 90px 40px 0;
          &::after {
            width: 43px;
            height: 45px;
            right:40px;
            bottom:35px;
          }
      `}
      ${maxWidth(vars.breakpoints.mobile)`
        padding: 0 60px 40px 0;
          &::after {
            width: 35px;
            height: 36px;
            right:20px;
            bottom:30px;
          }
      `}
    }

    ${Hero.Img} {
      min-height: 677px;
      ${maxWidth(vars.breakpoints.tablet)`
        min-height: 360px;
      `}
    }
    ${Hero.Title} {
      max-width: unset;
      font-size:var(--hero-title-font-size);
    }

    ${Breadcrumbs} {
      margin-top:20px;
    }
  `} 
  
  ${(props) =>
    props.size === 'mid' &&
    css`
      ${Hero.Container} {
        padding: 0 40px;

        ${maxWidth(vars.breakpoints.tablet)`
          padding: 0;
        `}
      }
      ${Hero.Content} {
        padding: 40px 0 0;

        ${maxWidth(vars.breakpoints.tablet)`
          padding: 26px 0 0;
        `}
      }

      ${Hero.Img} {
        min-height: 354px;

        ${maxWidth(vars.breakpoints.tablet)`
          min-height: 360px;
        `}
      }
      ${Hero.Title},
      ${Hero.Desc} {
        max-width: 902px;
      }
      ${Hero.Title} {
        font-size: 40px;
      }
      ${Hero.Desc} {
        font-size: 20px;

        ${maxWidth(vars.breakpoints.tablet)`
          font-size:16px;
          margin-top:15px;
        `}
      }
    `}

  ${(props) =>
  props.size === 'x-mid' &&
  css`
    ${Hero.Container} {
      padding: 0 40px;

      ${maxWidth(vars.breakpoints.tablet)`
          padding: 0;
        `}
    }
    ${Hero.Content} {
      padding: 0 0 5px;

      ${maxWidth(vars.breakpoints.tablet)`
          padding: 2px 0 0;
        `}
    }

    ${Hero.Img} {
      min-height: 303px;

      ${maxWidth(vars.breakpoints.tablet)`
          min-height: 360px;
        `}
    }
    ${Hero.Title},
    ${Hero.Desc} {
      max-width: 902px;
    }
    ${Hero.Title} {
      font-size: 40px;
    }
    ${Hero.Desc} {
      font-size: 20px;

      ${maxWidth(vars.breakpoints.tablet)`
          font-size:16px;
          margin-top:15px;
        `}
    }
  `}

  ${(props) =>
  props.size === 'small' &&
  css`
    ${Hero.Container} {
      padding: 0;
    }
    ${Hero.Content} {
      padding: 0;
    }

    ${Hero.Img} {
      min-height: 77px;
    }
    ${Hero.Title} {
      max-width: unset;
    }
    ${Hero.Title} {
      font-size: 28px;
      max-height: 67px;
    }
  `}

  ${(props) =>
  props.size === 'l-small' &&
  css`
    ${Hero.Container} {
      padding: 0;
    }
    ${Hero.Content} {
      padding: 0;
    }

    ${Hero.Img} {
      min-height: 100px;
    }
    ${Hero.Desc} {
      max-width: unset;
      font-size: 18px;
      color: #acacac;
      margin-top: 0;
    }
    ${Hero.Title} {
      max-width: unset;
      font-size: 34px;
      max-height: 41px;
      text-transform: uppercase;
      ${maxWidth(vars.breakpoints.tablet)`
        font-size: 28px;
      `}
    }
  `}
  
  ${(props) =>
    props.hiddenTablet &&
    css`
      ${maxWidth(vars.breakpoints.tablet)`
        display:none;
      `}
    `}
`;
Hero.Container = styled(Container)`
  padding: 0 110px;

  ${maxWidth(vars.breakpoints.xsDesktop)`
    padding: 0 80px;
  `}
  ${maxWidth(vars.breakpoints.tablet)`
    padding: 0;
  `}
`;

Hero.Item = styled.div`
  --gradient-main-color: 243, 244, 247;

  ${(props) =>
    props.theme === 'dark' &&
    css`
      --hero-title-color: #fff;
      --hero-desc-color: #fff;
      --hero-link-color: #fff;
      --hero-link-hover-color: rgba(255, 255, 255, 0.75);
      --gradient-main-color: 0, 0, 0;
    `}
`;

Hero.Img = styled.div`
  position: relative;
  z-index: -1;
  width: 100%;
  height: auto;
  min-height: 635px;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(var(--gradient-main-color), 0.4);
  }

  ${maxWidth(vars.breakpoints.tablet)`
    min-height: 500px;
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    min-height: 387px;
  `}
`;

Hero.Video = styled.div`
  position: relative;
  z-index: -1;
  width: 100%;
  height: auto;
  min-height: 635px;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(var(--gradient-main-color), 0.4);
    pointer-events: none;
  }

  ${maxWidth(vars.breakpoints.tablet)`
    min-height: 500px;
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    min-height: 387px;
  `}
`;

Hero.Pagination = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  & > ${Hero.Container} {
    position: relative;
    height: 100%;
  }

  .swiper-pagination-lock.swiper-pagination {
    display: none;
  }

  .swiper-pagination {
    top: unset;
    bottom: 84px;
    left: 110px;
    display: flex;
    gap: 15px;

    ${maxWidth(vars.breakpoints.tablet)`
      bottom: 38px;
      left: 5px;
    `}
  }

  .swiper-pagination-bullet {
    width: 7px;
    height: 7px;
    background-color: #000000;
    &:after {
      display: none;
    }
  }

  .swiper-pagination-bullet-active {
    background-color: #fff;
  }
`;

Hero.Content = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 76px;
  padding-bottom: 90px;

  ${(props) =>
    props.video &&
    css`
      pointer-events: none;
    `}

  ${maxWidth(1000)`
    padding-top: 10px;
    padding-bottom: 10px;
  `}

  & > ${Container} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
  ${Breadcrumbs} {
    margin-top: 40px;

    ${maxWidth(vars.breakpoints.tablet)`
      margin-top:35px;
    `}
  }
`;

Hero.Title = styled.h2`
  --hero-title-font-size: 64px;
  --hero-title-line-height: 1.2;
  --hero-title-max-lines: 2;

  display: block;
  display: -webkit-box;
  max-height: calc(var(--hero-title-font-size) * var(--hero-title-line-height) * var(--hero-title-max-lines));
  -webkit-line-clamp: var(--hero-title-max-lines);
  -moz-line-clamp: var(--hero-title-max-lines);
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  max-width: 65%;

  font-weight: 300;
  font-size: var(--hero-title-font-size);
  line-height: var(--hero-title-line-height);
  letter-spacing: -0.01em;
  color: var(--hero-title-color, #323232);
  pointer-events: none;

  ${maxWidth(vars.breakpoints.xsDesktop)`
    --hero-title-font-size: 50px;
  `}

  ${maxWidth(1000)`
    display: block;
    max-height: none;
    max-width: 620px;
  `}

  ${maxWidth(vars.breakpoints.tablet)`
    --hero-title-font-size: 40px;
  `}
`;

Hero.TitleH1 = styled.h1`
  --hero-title-font-size: 64px;
  --hero-title-line-height: 1.2;
  --hero-title-max-lines: 2;

  display: block;
  display: -webkit-box;
  max-height: calc(var(--hero-title-font-size) * var(--hero-title-line-height) * var(--hero-title-max-lines));
  -webkit-line-clamp: var(--hero-title-max-lines);
  -moz-line-clamp: var(--hero-title-max-lines);
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  max-width: 65%;

  font-weight: 300;
  font-size: var(--hero-title-font-size);
  line-height: var(--hero-title-line-height);
  letter-spacing: -0.01em;
  color: var(--hero-title-color, #323232);
  pointer-events: none;

  ${maxWidth(vars.breakpoints.xsDesktop)`
    --hero-title-font-size: 50px;
  `}

  ${maxWidth(1000)`
    display: block;
    max-height: none;
    max-width: 620px;
  `}

  ${maxWidth(vars.breakpoints.tablet)`
    --hero-title-font-size: 40px;
  `}
`;

Hero.Desc = styled.p`
  --hero-desc-font-size: 24px;
  --hero-desc-line-height: 1.2;
  --hero-desc-max-lines: 2;

  max-width: 65%;

  display: block;
  display: -webkit-box;
  max-height: calc(var(--hero-desc-font-size) * var(--hero-desc-line-height) * var(--hero-desc-max-lines));
  -webkit-line-clamp: var(--hero-desc-max-lines);
  -moz-line-clamp: var(--hero-desc-max-lines);
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  margin-top: 20px;
  font-weight: normal;
  font-size: var(--hero-desc-font-size);
  line-height: var(--hero-desc-line-height);
  letter-spacing: -0.01em;
  color: var(--hero-desc-color, #323232);
  pointer-events: none;

  ${maxWidth(1150)`
    margin-top: 18px;
  `}

  ${maxWidth(1000)`
    display: block;
    max-height: none;
    max-width: 620px;
    margin-top: 22px;
  `}

  ${maxWidth(vars.breakpoints.tablet)`
    --hero-desc-font-size: 20px;
    padding-left:5px;
  `}
`;

Hero.Footer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 40px;
  column-gap: 45px;
  row-gap: 10px;

  ${maxWidth(vars.breakpoints.mDesktop - 1)`
    margin-top: 36px;
  `}

  ${maxWidth(1150)`
    margin-top: 24px;
  `}

  ${maxWidth(1000)`
    margin-top: 28px;
  `}
`;

Hero.Link = styled.a`
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

Hero.More = styled.div`
  pointer-events: none;

  & > * {
    display: flex;
    align-items: center;
    gap: 5px;
    height: 50px;
    padding: 0 35px;
    background: #fff;
    border-radius: 90px;
    font-weight: 400;
    font-size: 16px;
    text-transform: uppercase;
    color: var(--color-decor, #b69b64);
    pointer-events: none;
    transition: color 0.3s ease-out, transform, opacity;

    &:after {
      content: '';
      display: block;
      width: 18px;
      height: 12px;
      background-image: url("data:image/svg+xml,%3Csvg width='18' height='12' viewBox='0 0 18 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.56189 11.5619L11.1238 6.00004L5.56189 0.438152' stroke='%23B69B64' /%3E%3Cpath d='M11.2628 11.5619L16.8247 5.99997L11.2628 0.43809' stroke='%23B69B64' /%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      transition: transform 0.3s ease-out;
    }
  }

  ${Hero.Item}:hover & > * {
    &:after {
      transform: translateX(5px);
    }
  }
`;

Hero.Button = styled.div`
  --button-transition: background 0.25s ease-out, transform, opacity;

  ${Button} {
    height: 50px;
    padding: 0 35px;
    border-radius: 90px;
    font-weight: 400;
    font-size: 16px;
  }

  ${maxWidth(vars.breakpoints.tablet)`
    --button-padding-top: 17px;
    --button-padding-bottom: 16px;
  `}

  ${maxWidth(1000)`
    --button-width: 300px;

    width: 100%;
    text-align: center;

  `}

  ${maxWidth(vars.breakpoints.mTablet)`
    --button-width: 100%;
  `}
`;

export default Hero;
